import "./pollyfill/customevent.ie11.js";

import Vue from "vue";
import CookieBanner from "./CookieBanner.vue";
import vmodal from "vue-js-modal";

import "./assets/fonts/cookie-banner-icons/cookie-banner-icons.css";
import { StpCookieBannerSettings } from "./interfaces/interfaces";

declare global {
  interface Window {
    StpCookieBanner: any;
  }
}

Vue.use(vmodal);

Vue.config.productionTip = false;

var elem = document.createElement("div");
elem.id = "cookie-banner";
document.body.appendChild(elem);

window.StpCookieBanner = {
  init: (settings: StpCookieBannerSettings) => {
    const vueInstance = new Vue({
      render: (h) =>
        h(CookieBanner, {
          props: settings,
        }),
    }).$mount("#cookie-banner");

    window.StpCookieBanner.instance = vueInstance.$children[0];
  },
};
